import { render } from "./ReviewStars.vue?vue&type=template&id=3901d35e"
import script from "./ReviewStars.vue?vue&type=script&lang=js"
export * from "./ReviewStars.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__